import { render } from "./ConsentCreator.vue?vue&type=template&id=c700cce8&scoped=true"
import script from "./ConsentCreator.vue?vue&type=script&lang=js"
export * from "./ConsentCreator.vue?vue&type=script&lang=js"

import "./ConsentCreator.vue?vue&type=style&index=0&id=c700cce8&scoped=true&lang=scss"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c700cce8"]])

export default __exports__